import { request } from 'services/http/instance'
import { GeneralGetRequest } from '../types'
import { mapDictionaryForResponse } from './mappers'

import {
  CreateDictionaryRequest,
  UpdateDictionaryRequest,
  Dictionary,
  DictionaryList,
} from './types'

export const create = (data: CreateDictionaryRequest) =>
  request<Dictionary>({
    method: 'post',
    url: 'localization',
    data,
  })

export const get = (params: GeneralGetRequest) =>
  request<DictionaryList>({
    method: 'get',
    url: 'localization',
    params,
  })

export const getById = (id: number) =>
  request<Dictionary>({
    method: 'get',
    url: `localization/get-by-id`,
    params: { id },
    mappers: {
      res: mapDictionaryForResponse,
    },
  })

export const update = (id: number, data: UpdateDictionaryRequest) =>
  request<Dictionary>({
    method: 'put',
    url: `localization`,
    data,
  })

export const del = (id: number) =>
  request<void>({
    method: 'delete',
    url: `localization/`,
    data: { id },
  })
